import styled from 'styled-components';

export const RewardOption = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  width: 800px;
  margin: auto;
  &.setting-reward {
    margin: 0;
    .reward-option {
      a {
        font-size: 10px;
        line-height: 12px;
      }
      p {
        margin-bottom: 0;
      }
    }
  }
  p {
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: #25282B;
    line-height: 16px;
    &.title {
      line-height: 24px;
      margin-bottom: 10px;
    }
  }
  .reward-options_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .reward-option {
      display: flex;
      padding: 0px 20px;
      flex-direction: column;
      width: 140px;
      height: 140px;
      align-items: center;
      .reward-option-img {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        img {
          &.gift {
            width: 92px;
          }
          &.crypto {
            width: 50px;
          }
          &.tshirt {
            width: 64px;
          }
          &.mug {
            width: 80px;
          }
          &.phone {
            width: 70px;
          }
        }
      }
      p {
        margin: 12px 0;
      }
    }
  }
  &.complete {
    .reward-options_container {
      .reward-option {
        border: 1px solid #E0E0E0;
        border-radius: 8px;
        margin: 12.5px;
        &:hover {
          border: 1px solid #c01ef0;
        }
        &.selected {
          border: 1px solid #1E87F0;
        }
      }
    }
  }
`;

export const GiftCryptoContainer = styled.div`
  margin: 40px auto;
  p {
    color: #4F4F4F;
    &.title {
      margin-bottom: 15px;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
    }
  }
  .GiftCrypto_body {
    display: flex;
    flex-direction: column;
    width: 350px;
    margin: auto;
    .sub_title,
    .sub_desc {
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: #4F4F4F;
      margin-bottom: 10px;
      text-align: left;
    }
    .sub_desc {
      margin-top: 10px;
    }
    .sub_hint {
      font-style: italic;
      font-weight: normal;
      font-size: 11px;
      line-height: 13px;
      color: #828282;
      text-align: left;
    }
    select {
      border-radius: 8px;
      border: 1px solid #BDBDBD;
      margin-bottom: 17px;
      padding: 9px 23px;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      height: 33px !important;
    }
    input {
      padding: 9px 23px;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      border: 1px solid #BDBDBD;
      box-sizing: border-box;
      border-radius: 8px;
      height: 33px;
    }
    .btn_container {
      display: flex;
      justify-content: flex-end;
      a {
        margin-right: 0;
      }
    }
  }
`;

export const GiftGoodsContainer = styled.div`
  margin: 40px auto;
  p {
    color: #4F4F4F;
    &.title {
      margin-bottom: 15px;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
    }
  }
  .GiftGoods_body {
    display: flex;
    flex-direction: column;
    width: 350px;
    margin: auto;
    .sub_title,
    .sub_desc {
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: #4F4F4F;
      margin-bottom: 10px;
      text-align: left;
    }
    .sub_desc {
      margin-top: 10px;
    }
    select {
      border-radius: 8px;
      border: 1px solid #BDBDBD;
      margin-bottom: 17px;
      padding: 9px 23px;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      height: 33px !important;
    }
    input {
      padding: 9px 23px;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      border: 1px solid #BDBDBD;
      box-sizing: border-box;
      border-radius: 8px;
      height: 33px;
    }
    .row {
      display: flex;
      flex-direction: row;
      .column {
        display: flex;
        flex-direction: column;
      }
    }
    .btn_container {
      display: flex;
      justify-content: flex-end;
      a {
        margin-right: 0;
      }
    }
  }
`;